import { ActionTree } from 'vuex';
import { StateType } from './state';

const actions: ActionTree<StateType, any> = {
  setLocale({ commit }, payload) {
    commit('setLanguage', payload)
  }
}

export default actions;